import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/auth/text-logo-light.svg")